import React, { useContext } from 'react';
import { Box } from 'rebass';
import styled from 'styled-components';

import { TypographyContext } from '../Typography/config';
import { theme } from '../../styles/theme';
import isDarkColour from '../../utils/isDarkColour';

const StyledContent = styled(Box)`
  & p {
    margin: ${theme.space[5]} 0;
    font-family: 'FoundersGrotesk', sans-serif;
    font-size: 20px;
    color: ${({ $isDark }) =>
      $isDark ? theme.colors.lightText : theme.colors.text};

    & > span {
      color: ${({ $isDark }) =>
        $isDark ? theme.colors.lightText : theme.colors.text};
    }

    &:first-child {
      margin-top: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }

    @media (min-width: ${theme.breakpoint.lg}) {
      margin: ${theme.space[6]} 0;
    }
  }

  h2,
  h3,
  h4,
  h5 {
    font-family: 'Helvetica Neue LT W05_43 Lt Ex', sans-serif;
    font-size: 36px;
  }

  ol,
  ul {
    margin: 0;
    padding-left: ${theme.space[5]};

    & > li {
      color: ${({ $isDark }) =>
        $isDark ? theme.colors.lightText : theme.colors.text};
      margin: ${theme.space[2]} 0;
    }
  }

  ol {
    counter-reset: numbered-li;
    list-style: none;

    @media (min-width: ${theme.breakpoint.lg}) {
      padding-left: ${theme.space[8]};
    }

    & > li {
      counter-increment: numbered-li;

      & > p > *:first-child {
        &::before {
          content: counter(numbered-li);
          margin-right: ${theme.space[3]};

          @media (min-width: ${theme.breakpoint.lg}) {
            margin-left: -${theme.space[5]};
          }
        }
      }
    }
  }

  hr {
    border: none;
    border-top: 1px solid currentColor;
    margin: ${theme.space[5]} 0;

    @media (min-width: ${theme.breakpoint.lg}) {
      margin: ${theme.space[8]} 0;
    }
  }

  .markup-ContentImage {
    margin: ${theme.space[5]} 0;

    @media (min-width: ${theme.breakpoint.lg}) {
      margin: ${theme.space[8]} 0;
    }
  }

  .twitter-tweet {
    margin-left: auto;
    margin-right: auto;
  }
`;

const Content = (props) => {
  const { colourScheme } = useContext(TypographyContext);
  const isDark = isDarkColour(colourScheme);

  return <StyledContent $isDark={isDark} {...props} />;
};

export default Content;
